import { useState } from 'react'

const useBlocksSidebar = () => {
  const [showBlocksSidebar, setShowBlocksSidebar] = useState(true)

  const openBlocksSidebar = () => setShowBlocksSidebar(true)

  const closeBlocksSidebar = () => setShowBlocksSidebar(false)

  return { showBlocksSidebar, openBlocksSidebar, closeBlocksSidebar }
}

export default useBlocksSidebar
